import { render, staticRenderFns } from "./FastSubmission.vue?vue&type=template&id=27ba1970&"
import script from "./FastSubmission.vue?vue&type=script&lang=js&"
export * from "./FastSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports